import styled, { css } from 'styled-components';
import { Tooltip } from "@heroui/react";
import { GenerateWithAIIcon } from '@components/userDocuments/editDocument/editJournal/toolset/assets/icons';
import { GenerateWithAIColor } from '@styling/theme';

const AIButton = styled.div`
  gap: 4px;
  padding: 0px 8px 0px 8px;
  height: 20px;
  background: ${(props) => props?.GenerateWithAIColor};
  border-radius: 5px;
  color: white;
  cursor: pointer;
  position: absolute;
  right: 4px;
  top: 4px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  ${(props) => {
    const { isGenerating, isEnableButton, isGenerateRangeCrossed } = props;
    if (isGenerating) {
      return css`
        cursor: not-allowed;
      `;
    }
    if (!isEnableButton || isGenerateRangeCrossed) {
      return css`
        cursor: not-allowed;
        background: gray;
      `;
    }
    return null;
  }}
`;

const ButtonWrapper = styled.div`
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
`;

const GenerateWithAIButton = ({
  toolTipContent,
  isGenerating,
  handleClick,
  isEnableButton,
  isGenerateRangeCrossed,
}) => {
  return (
    <ButtonWrapper>
      <Tooltip
        placement="right-start"
        content={
          <span className="w-36">
            <span className="text-[11px]">{toolTipContent}</span>
          </span>
        }
        isDisabled={isEnableButton && !isGenerateRangeCrossed}
        contentEditable={false}
      >
        <AIButton
          isGenerating={isGenerating}
          onClick={handleClick}
          isEnableButton={isEnableButton}
          contentEditable={false}
          GenerateWithAIColor={GenerateWithAIColor}
          isGenerateRangeCrossed={isGenerateRangeCrossed}
          aria-label="Generate with AI"
        >
          <span contentEditable={false}>
            <GenerateWithAIIcon isActive="true" />
          </span>
          <span contentEditable={false}>Generate with AI</span>
        </AIButton>
      </Tooltip>
    </ButtonWrapper>
  );
};

export default GenerateWithAIButton;
